export default "__VITE_ASSET__DOxtcRpD__"